/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { NAVIGATION_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_FILTERS_VIEW_ALL } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { ViewAllEntityMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/view-all-entity-menu-item/index.tsx';
import { filtersDirectoryRoute } from '@jira/router-routes__directories-routes/src/filtersDirectoryRoute.tsx';
import { useFilterActionsAnalytics } from '../../utils/analytics/index.tsx';

const viewAllFilters = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'View all filters',
	description: 'Message for the view all filters menu item in the filters submenu',
});

const VIEW_ALL_FILTERS_PATH = filtersDirectoryRoute.path;

export function Footer(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const sendFilterAnalytics = useFilterActionsAnalytics();
	const sendDefaultFilterDropdownAnalytics = useCallback(() => {
		sendFilterAnalytics(NAVIGATION_ITEM, {
			level: LEVEL_ONE,
			componentType: FIXED_ITEM,
			itemId: 'viewAllFilters',
		});
	}, [sendFilterAnalytics]);
	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<ViewAllEntityMenuItem
						onClick={sendDefaultFilterDropdownAnalytics}
						href={VIEW_ALL_FILTERS_PATH}
						menuId={MENU_ID_FILTERS_VIEW_ALL}
					>
						{formatMessage(viewAllFilters)}
					</ViewAllEntityMenuItem>
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
}
